var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10.823,
  height: 16.84
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".back_svg__cls-1{fill:none;stroke:#1291d9;stroke-linecap:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "back_svg__\\uD654\\uC0B4\\uD45C_\\uC67C\\uCABD_\\uD30C\\uB791\\uC0C9",
  transform: "translate(1.412 1.411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "back_svg__icn_back",
  transform: "rotate(180 4 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "back_svg__\\uC120_17",
  d: "M0 6.981 8 0",
  className: "back_svg__cls-1",
  transform: "translate(0 7.019)"
}), /*#__PURE__*/React.createElement("path", {
  id: "back_svg__\\uD328\\uC2A4_44",
  d: "m0 0 7.921 7.035",
  className: "back_svg__cls-1",
  transform: "translate(.079 -.017)"
})))));
export { SvgBack as ReactComponent };
export default __webpack_public_path__ + "static/media/back.a81f8c25.svg";